import { render, staticRenderFns } from "./ArchivedRecords.vue?vue&type=template&id=95dfaa10&"
import script from "./ArchivedRecords.vue?vue&type=script&lang=js&"
export * from "./ArchivedRecords.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports